<template>
    <div class="ml-3 mr-3">
        <h5 class="text-center mb-4">Link Authorizations</h5>
        <div class="d-flex">
            <div class="input-group input-group-sm mb-1">
                <div class="input-group-prepend">
                    <div class="input-group-text"><i class="fas fa-search fa-sm text-muted"></i></div>
                </div>
                <input type="text" class="form-control" placeholder="Search Descriptions" v-model="searchString">
            </div>                   
        </div>
        <div>
            <table class="table table-sm font-smaller mb-3">
                <thead>
                    <tr>
                        <th></th>
                        <th>Document</th>
                        <th>Submitted</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="filteredDocuments.length">
                        <tr v-for="doc in filteredDocuments" :key="'dispute-authorization-' + doc.id">
                            <td class="fit">
                                <div class="custom-control custom-checkbox">
                                    <input :id="'dispute-authorization-checkbox-' + doc.id" type="checkbox" class="custom-control-input" v-model="doc.selected" @change="onChange($event, doc)">
                                    <label class="custom-control-label align-top" :for="'dispute-authorization-checkbox-' + doc.id">
                                        <span class="sr-only"></span>
                                    </label>
                                </div>                                       
                            </td>
                            <td>
                                <document-status-icon class="icon-small" :document-id="doc.id" :document-status="doc.document_status"></document-status-icon>                                         
                                <span :title="doc.document_type.name + ' - ' + doc.description">{{ doc.document_type.name }} - {{ doc.description | truncate(70) }}</span>
                            </td>
                            <td class="fit">{{ doc.submitted_at | localizeTime('YYYY-MM-DD HH:mm:ss')  }}</td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr><td class="text-center text-muted" colspan="3"><h5>No Documents</h5></td></tr>
                    </template>
                </tbody>
            </table>
        </div>        
    </div>    
</template>

<script>
import DocumentStatusIcon from '../documents/DocumentStatusIconComponent.vue';

export default {
    components: {
        DocumentStatusIcon
    },    
    props: {
        authorizations: Array
    },
    data() {
        return {
            searchString: ''
        }
    },
    computed: {
         filteredDocuments: function () {
            const self = this;
             return self.authorizations.filter(e => e.description.toLowerCase().indexOf(self.searchString.toLowerCase()) !== -1);
         }         
    },
    methods: {
        onChange: function (e, document) {
            this.$emit('associate', document, e.target.checked);
        }        
    }
}
</script>

<style scoped>
    .icon-small {
        font-size: 1em;
    }
</style>